var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5599 5.71922V8.35922C10.5599 8.84523 10.9539 9.23922 11.4399 9.23922H14.0799M15.8399 2.19922H9.67972C8.7077 2.19922 7.91972 2.98719 7.91972 3.95921V5.71922M15.8399 2.19922H16.3308C16.5787 2.19922 16.8146 2.3036 16.9853 2.48322C17.2419 2.75316 17.6483 3.16879 18.0399 3.51922C18.3469 3.79387 18.8291 4.28676 19.1179 4.58632C19.2741 4.74831 19.3599 4.96461 19.3599 5.18963L19.3599 5.71922M15.8399 2.19922V4.83922C15.8399 5.32523 16.2339 5.71922 16.7199 5.71922H19.3599M19.3599 5.71922L19.3597 14.5193C19.3597 15.4913 18.5717 16.2792 17.5997 16.2792H14.0797M12.7599 7.03922C12.3683 6.68879 11.9619 6.27316 11.7053 6.00322C11.5346 5.8236 11.2987 5.71922 11.0508 5.71922H4.39972C3.4277 5.71922 2.63972 6.50719 2.63972 7.47921L2.63965 18.0392C2.63964 19.0112 3.42762 19.7992 4.39964 19.7992L12.3197 19.7992C13.2917 19.7992 14.0797 19.0113 14.0797 18.0393L14.0799 8.70963C14.0799 8.48462 13.9941 8.26831 13.8379 8.10632C13.5491 7.80676 13.0669 7.31387 12.7599 7.03922Z",
    stroke: "#06513D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFile);
export default __webpack_public_path__ + "static/media/greenFile.dcd9ad4340fe05e5373a5ccbb3a2d793.svg";
export { ForwardRef as ReactComponent };